import { render, staticRenderFns } from "./ReportDesktopMorePackages.vue?vue&type=template&id=56cb0e00"
import script from "./ReportDesktopMorePackages.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMorePackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports